import { __commonJS } from "./chunk-B4qE4VCv.mjs";
import { require_function } from "./function-CN-GVuiB.mjs";
import { require_internal } from "./Functor-CElCX-_O.mjs";

//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Eq.js
var require_Eq = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Eq.js": ((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.eqDate = exports.eqNumber = exports.eqString = exports.eqBoolean = exports.eq = exports.strictEqual = exports.getStructEq = exports.getTupleEq = exports.Contravariant = exports.getMonoid = exports.getSemigroup = exports.eqStrict = exports.URI = exports.contramap = exports.tuple = exports.struct = exports.fromEquals = void 0;
	var function_1$2 = require_function();
	/**
	* @category constructors
	* @since 2.0.0
	*/
	var fromEquals = function(equals$1) {
		return { equals: function(x, y) {
			return x === y || equals$1(x, y);
		} };
	};
	exports.fromEquals = fromEquals;
	/**
	* @since 2.10.0
	*/
	var struct$1 = function(eqs) {
		return (0, exports.fromEquals)(function(first$1, second) {
			for (var key in eqs) if (!eqs[key].equals(first$1[key], second[key])) return false;
			return true;
		});
	};
	exports.struct = struct$1;
	/**
	* Given a tuple of `Eq`s returns a `Eq` for the tuple
	*
	* @example
	* import { tuple } from 'fp-ts/Eq'
	* import * as S from 'fp-ts/string'
	* import * as N from 'fp-ts/number'
	* import * as B from 'fp-ts/boolean'
	*
	* const E = tuple(S.Eq, N.Eq, B.Eq)
	* assert.strictEqual(E.equals(['a', 1, true], ['a', 1, true]), true)
	* assert.strictEqual(E.equals(['a', 1, true], ['b', 1, true]), false)
	* assert.strictEqual(E.equals(['a', 1, true], ['a', 2, true]), false)
	* assert.strictEqual(E.equals(['a', 1, true], ['a', 1, false]), false)
	*
	* @since 2.10.0
	*/
	var tuple$2 = function() {
		var eqs = [];
		for (var _i = 0; _i < arguments.length; _i++) eqs[_i] = arguments[_i];
		return (0, exports.fromEquals)(function(first$1, second) {
			return eqs.every(function(E, i) {
				return E.equals(first$1[i], second[i]);
			});
		});
	};
	exports.tuple = tuple$2;
	/* istanbul ignore next */
	var contramap_$1 = function(fa, f) {
		return (0, function_1$2.pipe)(fa, (0, exports.contramap)(f));
	};
	/**
	* A typical use case for `contramap` would be like, given some `User` type, to construct an `Eq<User>`.
	*
	* We can do so with a function from `User -> X` where `X` is some value that we know how to compare
	* for equality (meaning we have an `Eq<X>`)
	*
	* For example, given the following `User` type, we want to construct an `Eq<User>` that just looks at the `key` field
	* for each user (since it's known to be unique).
	*
	* If we have a way of comparing `UUID`s for equality (`eqUUID: Eq<UUID>`) and we know how to go from `User -> UUID`,
	* using `contramap` we can do this
	*
	* @example
	* import { contramap, Eq } from 'fp-ts/Eq'
	* import { pipe } from 'fp-ts/function'
	* import * as S from 'fp-ts/string'
	*
	* type UUID = string
	*
	* interface User {
	*   readonly key: UUID
	*   readonly firstName: string
	*   readonly lastName: string
	* }
	*
	* const eqUUID: Eq<UUID> = S.Eq
	*
	* const eqUserByKey: Eq<User> = pipe(
	*   eqUUID,
	*   contramap((user) => user.key)
	* )
	*
	* assert.deepStrictEqual(
	*   eqUserByKey.equals(
	*     { key: 'k1', firstName: 'a1', lastName: 'b1' },
	*     { key: 'k2', firstName: 'a1', lastName: 'b1' }
	*   ),
	*   false
	* )
	* assert.deepStrictEqual(
	*   eqUserByKey.equals(
	*     { key: 'k1', firstName: 'a1', lastName: 'b1' },
	*     { key: 'k1', firstName: 'a2', lastName: 'b1' }
	*   ),
	*   true
	* )
	*
	* @since 2.0.0
	*/
	var contramap$1 = function(f) {
		return function(fa) {
			return (0, exports.fromEquals)(function(x, y) {
				return fa.equals(f(x), f(y));
			});
		};
	};
	exports.contramap = contramap$1;
	/**
	* @category type lambdas
	* @since 2.0.0
	*/
	exports.URI = "Eq";
	/**
	* @category instances
	* @since 2.5.0
	*/
	exports.eqStrict = { equals: function(a, b) {
		return a === b;
	} };
	var empty = { equals: function() {
		return true;
	} };
	/**
	* @category instances
	* @since 2.10.0
	*/
	var getSemigroup$1 = function() {
		return { concat: function(x, y) {
			return (0, exports.fromEquals)(function(a, b) {
				return x.equals(a, b) && y.equals(a, b);
			});
		} };
	};
	exports.getSemigroup = getSemigroup$1;
	/**
	* @category instances
	* @since 2.6.0
	*/
	var getMonoid$1 = function() {
		return {
			concat: (0, exports.getSemigroup)().concat,
			empty
		};
	};
	exports.getMonoid = getMonoid$1;
	/**
	* @category instances
	* @since 2.7.0
	*/
	exports.Contravariant = {
		URI: exports.URI,
		contramap: contramap_$1
	};
	/**
	* Use [`tuple`](#tuple) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getTupleEq = exports.tuple;
	/**
	* Use [`struct`](#struct) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getStructEq = exports.struct;
	/**
	* Use [`eqStrict`](#eqstrict) instead
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.strictEqual = exports.eqStrict.equals;
	/**
	* This instance is deprecated, use small, specific instances instead.
	* For example if a function needs a `Contravariant` instance, pass `E.Contravariant` instead of `E.eq`
	* (where `E` is from `import E from 'fp-ts/Eq'`)
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.eq = exports.Contravariant;
	/**
	* Use [`Eq`](./boolean.ts.html#eq) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.eqBoolean = exports.eqStrict;
	/**
	* Use [`Eq`](./string.ts.html#eq) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.eqString = exports.eqStrict;
	/**
	* Use [`Eq`](./number.ts.html#eq) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.eqNumber = exports.eqStrict;
	/**
	* Use [`Eq`](./Date.ts.html#eq) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.eqDate = { equals: function(first$1, second) {
		return first$1.valueOf() === second.valueOf();
	} };
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Ord.js
var require_Ord = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Ord.js": ((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ordDate = exports.ordNumber = exports.ordString = exports.ordBoolean = exports.ord = exports.getDualOrd = exports.getTupleOrd = exports.between = exports.clamp = exports.max = exports.min = exports.geq = exports.leq = exports.gt = exports.lt = exports.equals = exports.trivial = exports.Contravariant = exports.getMonoid = exports.getSemigroup = exports.URI = exports.contramap = exports.reverse = exports.tuple = exports.fromCompare = exports.equalsDefault = void 0;
	var Eq_1 = require_Eq();
	var function_1$1 = require_function();
	/**
	* @category defaults
	* @since 2.10.0
	*/
	var equalsDefault = function(compare$1) {
		return function(first$1, second) {
			return first$1 === second || compare$1(first$1, second) === 0;
		};
	};
	exports.equalsDefault = equalsDefault;
	/**
	* @category constructors
	* @since 2.0.0
	*/
	var fromCompare = function(compare$1) {
		return {
			equals: (0, exports.equalsDefault)(compare$1),
			compare: function(first$1, second) {
				return first$1 === second ? 0 : compare$1(first$1, second);
			}
		};
	};
	exports.fromCompare = fromCompare;
	/**
	* Given a tuple of `Ord`s returns an `Ord` for the tuple.
	*
	* @example
	* import { tuple } from 'fp-ts/Ord'
	* import * as B from 'fp-ts/boolean'
	* import * as S from 'fp-ts/string'
	* import * as N from 'fp-ts/number'
	*
	* const O = tuple(S.Ord, N.Ord, B.Ord)
	* assert.strictEqual(O.compare(['a', 1, true], ['b', 2, true]), -1)
	* assert.strictEqual(O.compare(['a', 1, true], ['a', 2, true]), -1)
	* assert.strictEqual(O.compare(['a', 1, true], ['a', 1, false]), 1)
	*
	* @since 2.10.0
	*/
	var tuple$1 = function() {
		var ords = [];
		for (var _i = 0; _i < arguments.length; _i++) ords[_i] = arguments[_i];
		return (0, exports.fromCompare)(function(first$1, second) {
			var i = 0;
			for (; i < ords.length - 1; i++) {
				var r = ords[i].compare(first$1[i], second[i]);
				if (r !== 0) return r;
			}
			return ords[i].compare(first$1[i], second[i]);
		});
	};
	exports.tuple = tuple$1;
	/**
	* @since 2.10.0
	*/
	var reverse$1 = function(O) {
		return (0, exports.fromCompare)(function(first$1, second) {
			return O.compare(second, first$1);
		});
	};
	exports.reverse = reverse$1;
	/* istanbul ignore next */
	var contramap_ = function(fa, f) {
		return (0, function_1$1.pipe)(fa, (0, exports.contramap)(f));
	};
	/**
	* A typical use case for `contramap` would be like, given some `User` type, to construct an `Ord<User>`.
	*
	* We can do so with a function from `User -> X` where `X` is some value that we know how to compare
	* for ordering (meaning we have an `Ord<X>`)
	*
	* For example, given the following `User` type, there are lots of possible choices for `X`,
	* but let's say we want to sort a list of users by `lastName`.
	*
	* If we have a way of comparing `lastName`s for ordering (`ordLastName: Ord<string>`) and we know how to go from `User -> string`,
	* using `contramap` we can do this
	*
	* @example
	* import { pipe } from 'fp-ts/function'
	* import { contramap, Ord } from 'fp-ts/Ord'
	* import * as RA from 'fp-ts/ReadonlyArray'
	* import * as S from 'fp-ts/string'
	*
	* interface User {
	*   readonly firstName: string
	*   readonly lastName: string
	* }
	*
	* const ordLastName: Ord<string> = S.Ord
	*
	* const ordByLastName: Ord<User> = pipe(
	*   ordLastName,
	*   contramap((user) => user.lastName)
	* )
	*
	* assert.deepStrictEqual(
	*   RA.sort(ordByLastName)([
	*     { firstName: 'a', lastName: 'd' },
	*     { firstName: 'c', lastName: 'b' }
	*   ]),
	*   [
	*     { firstName: 'c', lastName: 'b' },
	*     { firstName: 'a', lastName: 'd' }
	*   ]
	* )
	*
	* @since 2.0.0
	*/
	var contramap = function(f) {
		return function(fa) {
			return (0, exports.fromCompare)(function(first$1, second) {
				return fa.compare(f(first$1), f(second));
			});
		};
	};
	exports.contramap = contramap;
	/**
	* @category type lambdas
	* @since 2.0.0
	*/
	exports.URI = "Ord";
	/**
	* A typical use case for the `Semigroup` instance of `Ord` is merging two or more orderings.
	*
	* For example the following snippet builds an `Ord` for a type `User` which
	* sorts by `created` date descending, and **then** `lastName`
	*
	* @example
	* import * as D from 'fp-ts/Date'
	* import { pipe } from 'fp-ts/function'
	* import { contramap, getSemigroup, Ord, reverse } from 'fp-ts/Ord'
	* import * as RA from 'fp-ts/ReadonlyArray'
	* import * as S from 'fp-ts/string'
	*
	* interface User {
	*   readonly id: string
	*   readonly lastName: string
	*   readonly created: Date
	* }
	*
	* const ordByLastName: Ord<User> = pipe(
	*   S.Ord,
	*   contramap((user) => user.lastName)
	* )
	*
	* const ordByCreated: Ord<User> = pipe(
	*   D.Ord,
	*   contramap((user) => user.created)
	* )
	*
	* const ordUserByCreatedDescThenLastName = getSemigroup<User>().concat(
	*   reverse(ordByCreated),
	*   ordByLastName
	* )
	*
	* assert.deepStrictEqual(
	*   RA.sort(ordUserByCreatedDescThenLastName)([
	*     { id: 'c', lastName: 'd', created: new Date(1973, 10, 30) },
	*     { id: 'a', lastName: 'b', created: new Date(1973, 10, 30) },
	*     { id: 'e', lastName: 'f', created: new Date(1980, 10, 30) }
	*   ]),
	*   [
	*     { id: 'e', lastName: 'f', created: new Date(1980, 10, 30) },
	*     { id: 'a', lastName: 'b', created: new Date(1973, 10, 30) },
	*     { id: 'c', lastName: 'd', created: new Date(1973, 10, 30) }
	*   ]
	* )
	*
	* @category instances
	* @since 2.0.0
	*/
	var getSemigroup = function() {
		return { concat: function(first$1, second) {
			return (0, exports.fromCompare)(function(a, b) {
				var ox = first$1.compare(a, b);
				return ox !== 0 ? ox : second.compare(a, b);
			});
		} };
	};
	exports.getSemigroup = getSemigroup;
	/**
	* Returns a `Monoid` such that:
	*
	* - its `concat(ord1, ord2)` operation will order first by `ord1`, and then by `ord2`
	* - its `empty` value is an `Ord` that always considers compared elements equal
	*
	* @example
	* import { sort } from 'fp-ts/Array'
	* import { contramap, reverse, getMonoid } from 'fp-ts/Ord'
	* import * as S from 'fp-ts/string'
	* import * as B from 'fp-ts/boolean'
	* import { pipe } from 'fp-ts/function'
	* import { concatAll } from 'fp-ts/Monoid'
	* import * as N from 'fp-ts/number'
	*
	* interface User {
	*   readonly id: number
	*   readonly name: string
	*   readonly age: number
	*   readonly rememberMe: boolean
	* }
	*
	* const byName = pipe(
	*   S.Ord,
	*   contramap((p: User) => p.name)
	* )
	*
	* const byAge = pipe(
	*   N.Ord,
	*   contramap((p: User) => p.age)
	* )
	*
	* const byRememberMe = pipe(
	*   B.Ord,
	*   contramap((p: User) => p.rememberMe)
	* )
	*
	* const M = getMonoid<User>()
	*
	* const users: Array<User> = [
	*   { id: 1, name: 'Guido', age: 47, rememberMe: false },
	*   { id: 2, name: 'Guido', age: 46, rememberMe: true },
	*   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
	*   { id: 4, name: 'Giulio', age: 44, rememberMe: true }
	* ]
	*
	* // sort by name, then by age, then by `rememberMe`
	* const O1 = concatAll(M)([byName, byAge, byRememberMe])
	* assert.deepStrictEqual(sort(O1)(users), [
	*   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
	*   { id: 4, name: 'Giulio', age: 44, rememberMe: true },
	*   { id: 2, name: 'Guido', age: 46, rememberMe: true },
	*   { id: 1, name: 'Guido', age: 47, rememberMe: false }
	* ])
	*
	* // now `rememberMe = true` first, then by name, then by age
	* const O2 = concatAll(M)([reverse(byRememberMe), byName, byAge])
	* assert.deepStrictEqual(sort(O2)(users), [
	*   { id: 4, name: 'Giulio', age: 44, rememberMe: true },
	*   { id: 2, name: 'Guido', age: 46, rememberMe: true },
	*   { id: 3, name: 'Giulio', age: 44, rememberMe: false },
	*   { id: 1, name: 'Guido', age: 47, rememberMe: false }
	* ])
	*
	* @category instances
	* @since 2.4.0
	*/
	var getMonoid = function() {
		return {
			concat: (0, exports.getSemigroup)().concat,
			empty: (0, exports.fromCompare)(function() {
				return 0;
			})
		};
	};
	exports.getMonoid = getMonoid;
	/**
	* @category instances
	* @since 2.7.0
	*/
	exports.Contravariant = {
		URI: exports.URI,
		contramap: contramap_
	};
	/**
	* @since 2.11.0
	*/
	exports.trivial = {
		equals: function_1$1.constTrue,
		compare: /* @__PURE__ */ (0, function_1$1.constant)(0)
	};
	/**
	* @since 2.11.0
	*/
	var equals = function(O) {
		return function(second) {
			return function(first$1) {
				return first$1 === second || O.compare(first$1, second) === 0;
			};
		};
	};
	exports.equals = equals;
	/**
	* Test whether one value is _strictly less than_ another
	*
	* @since 2.0.0
	*/
	var lt = function(O) {
		return function(first$1, second) {
			return O.compare(first$1, second) === -1;
		};
	};
	exports.lt = lt;
	/**
	* Test whether one value is _strictly greater than_ another
	*
	* @since 2.0.0
	*/
	var gt = function(O) {
		return function(first$1, second) {
			return O.compare(first$1, second) === 1;
		};
	};
	exports.gt = gt;
	/**
	* Test whether one value is _non-strictly less than_ another
	*
	* @since 2.0.0
	*/
	var leq = function(O) {
		return function(first$1, second) {
			return O.compare(first$1, second) !== 1;
		};
	};
	exports.leq = leq;
	/**
	* Test whether one value is _non-strictly greater than_ another
	*
	* @since 2.0.0
	*/
	var geq = function(O) {
		return function(first$1, second) {
			return O.compare(first$1, second) !== -1;
		};
	};
	exports.geq = geq;
	/**
	* Take the minimum of two values. If they are considered equal, the first argument is chosen
	*
	* @since 2.0.0
	*/
	var min$1 = function(O) {
		return function(first$1, second) {
			return first$1 === second || O.compare(first$1, second) < 1 ? first$1 : second;
		};
	};
	exports.min = min$1;
	/**
	* Take the maximum of two values. If they are considered equal, the first argument is chosen
	*
	* @since 2.0.0
	*/
	var max$1 = function(O) {
		return function(first$1, second) {
			return first$1 === second || O.compare(first$1, second) > -1 ? first$1 : second;
		};
	};
	exports.max = max$1;
	/**
	* Clamp a value between a minimum and a maximum
	*
	* @since 2.0.0
	*/
	var clamp = function(O) {
		var minO = (0, exports.min)(O);
		var maxO = (0, exports.max)(O);
		return function(low, hi) {
			return function(a) {
				return maxO(minO(a, hi), low);
			};
		};
	};
	exports.clamp = clamp;
	/**
	* Test whether a value is between a minimum and a maximum (inclusive)
	*
	* @since 2.0.0
	*/
	var between = function(O) {
		var ltO = (0, exports.lt)(O);
		var gtO = (0, exports.gt)(O);
		return function(low, hi) {
			return function(a) {
				return ltO(a, low) || gtO(a, hi) ? false : true;
			};
		};
	};
	exports.between = between;
	/**
	* Use [`tuple`](#tuple) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getTupleOrd = exports.tuple;
	/**
	* Use [`reverse`](#reverse) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getDualOrd = exports.reverse;
	/**
	* Use [`Contravariant`](#contravariant) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.ord = exports.Contravariant;
	function compare(first$1, second) {
		return first$1 < second ? -1 : first$1 > second ? 1 : 0;
	}
	var strictOrd = {
		equals: Eq_1.eqStrict.equals,
		compare
	};
	/**
	* Use [`Ord`](./boolean.ts.html#ord) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.ordBoolean = strictOrd;
	/**
	* Use [`Ord`](./string.ts.html#ord) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.ordString = strictOrd;
	/**
	* Use [`Ord`](./number.ts.html#ord) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.ordNumber = strictOrd;
	/**
	* Use [`Ord`](./Date.ts.html#ord) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.ordDate = (0, function_1$1.pipe)(exports.ordNumber, /* @__PURE__ */ (0, exports.contramap)(function(date) {
		return date.valueOf();
	}));
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Magma.js
var require_Magma = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Magma.js": ((exports) => {
	/**
	* A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
	*
	* See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
	*
	* @since 2.0.0
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	* The dual of a `Magma`, obtained by swapping the arguments of `concat`.
	*
	* @example
	* import { reverse, concatAll } from 'fp-ts/Magma'
	* import * as N from 'fp-ts/number'
	*
	* const subAll = concatAll(reverse(N.MagmaSub))(0)
	*
	* assert.deepStrictEqual(subAll([1, 2, 3]), 2)
	*
	* @since 2.11.0
	*/
	var reverse = function(M$1) {
		return { concat: function(first$1, second) {
			return M$1.concat(second, first$1);
		} };
	};
	exports.reverse = reverse;
	/**
	* @since 2.11.0
	*/
	var filterFirst = function(predicate) {
		return function(M$1) {
			return { concat: function(first$1, second) {
				return predicate(first$1) ? M$1.concat(first$1, second) : second;
			} };
		};
	};
	exports.filterFirst = filterFirst;
	/**
	* @since 2.11.0
	*/
	var filterSecond = function(predicate) {
		return function(M$1) {
			return { concat: function(first$1, second) {
				return predicate(second) ? M$1.concat(first$1, second) : first$1;
			} };
		};
	};
	exports.filterSecond = filterSecond;
	/**
	* @since 2.11.0
	*/
	var endo = function(f) {
		return function(M$1) {
			return { concat: function(first$1, second) {
				return M$1.concat(f(first$1), f(second));
			} };
		};
	};
	exports.endo = endo;
	/**
	* Given a sequence of `as`, concat them and return the total.
	*
	* If `as` is empty, return the provided `startWith` value.
	*
	* @example
	* import { concatAll } from 'fp-ts/Magma'
	* import * as N from 'fp-ts/number'
	*
	* const subAll = concatAll(N.MagmaSub)(0)
	*
	* assert.deepStrictEqual(subAll([1, 2, 3]), -6)
	*
	* @since 2.11.0
	*/
	var concatAll = function(M$1) {
		return function(startWith) {
			return function(as) {
				return as.reduce(function(a, acc) {
					return M$1.concat(a, acc);
				}, startWith);
			};
		};
	};
	exports.concatAll = concatAll;
}) });

//#endregion
//#region node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Semigroup.js
var require_Semigroup = /* @__PURE__ */ __commonJS({ "node_modules/.deno/fp-ts@2.16.10/node_modules/fp-ts/lib/Semigroup.js": ((exports) => {
	var __createBinding = exports && exports.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? (function(o, v) {
		Object.defineProperty(o, "default", {
			enumerable: true,
			value: v
		});
	}) : function(o, v) {
		o["default"] = v;
	});
	var __importStar = exports && exports.__importStar || function(mod) {
		if (mod && mod.__esModule) return mod;
		var result = {};
		if (mod != null) {
			for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		}
		__setModuleDefault(result, mod);
		return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.semigroupProduct = exports.semigroupSum = exports.semigroupString = exports.getFunctionSemigroup = exports.semigroupAny = exports.semigroupAll = exports.getIntercalateSemigroup = exports.getMeetSemigroup = exports.getJoinSemigroup = exports.getDualSemigroup = exports.getStructSemigroup = exports.getTupleSemigroup = exports.getFirstSemigroup = exports.getLastSemigroup = exports.getObjectSemigroup = exports.semigroupVoid = exports.concatAll = exports.last = exports.first = exports.intercalate = exports.tuple = exports.struct = exports.reverse = exports.constant = exports.max = exports.min = void 0;
	exports.fold = fold;
	/**
	* If a type `A` can form a `Semigroup` it has an **associative** binary operation.
	*
	* ```ts
	* interface Semigroup<A> {
	*   readonly concat: (x: A, y: A) => A
	* }
	* ```
	*
	* Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
	*
	* ```ts
	* concat(x, concat(y, z)) = concat(concat(x, y), z)
	* ```
	*
	* A common example of a semigroup is the type `string` with the operation `+`.
	*
	* ```ts
	* import { Semigroup } from 'fp-ts/Semigroup'
	*
	* const semigroupString: Semigroup<string> = {
	*   concat: (x, y) => x + y
	* }
	*
	* const x = 'x'
	* const y = 'y'
	* const z = 'z'
	*
	* semigroupString.concat(x, y) // 'xy'
	*
	* semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
	*
	* semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
	* ```
	*
	* *Adapted from https://typelevel.org/cats*
	*
	* @since 2.0.0
	*/
	var function_1 = require_function();
	var _ = __importStar(require_internal());
	var M = __importStar(require_Magma());
	var Or = __importStar(require_Ord());
	/**
	* Get a semigroup where `concat` will return the minimum, based on the provided order.
	*
	* @example
	* import * as N from 'fp-ts/number'
	* import * as S from 'fp-ts/Semigroup'
	*
	* const S1 = S.min(N.Ord)
	*
	* assert.deepStrictEqual(S1.concat(1, 2), 1)
	*
	* @category constructors
	* @since 2.10.0
	*/
	var min = function(O) {
		return { concat: Or.min(O) };
	};
	exports.min = min;
	/**
	* Get a semigroup where `concat` will return the maximum, based on the provided order.
	*
	* @example
	* import * as N from 'fp-ts/number'
	* import * as S from 'fp-ts/Semigroup'
	*
	* const S1 = S.max(N.Ord)
	*
	* assert.deepStrictEqual(S1.concat(1, 2), 2)
	*
	* @category constructors
	* @since 2.10.0
	*/
	var max = function(O) {
		return { concat: Or.max(O) };
	};
	exports.max = max;
	/**
	* @category constructors
	* @since 2.10.0
	*/
	var constant = function(a) {
		return { concat: function() {
			return a;
		} };
	};
	exports.constant = constant;
	/**
	* The dual of a `Semigroup`, obtained by swapping the arguments of `concat`.
	*
	* @example
	* import { reverse } from 'fp-ts/Semigroup'
	* import * as S from 'fp-ts/string'
	*
	* assert.deepStrictEqual(reverse(S.Semigroup).concat('a', 'b'), 'ba')
	*
	* @since 2.10.0
	*/
	exports.reverse = M.reverse;
	/**
	* Given a struct of semigroups returns a semigroup for the struct.
	*
	* @example
	* import { struct } from 'fp-ts/Semigroup'
	* import * as N from 'fp-ts/number'
	*
	* interface Point {
	*   readonly x: number
	*   readonly y: number
	* }
	*
	* const S = struct<Point>({
	*   x: N.SemigroupSum,
	*   y: N.SemigroupSum
	* })
	*
	* assert.deepStrictEqual(S.concat({ x: 1, y: 2 }, { x: 3, y: 4 }), { x: 4, y: 6 })
	*
	* @since 2.10.0
	*/
	var struct = function(semigroups) {
		return { concat: function(first$1, second) {
			var r = {};
			for (var k in semigroups) if (_.has.call(semigroups, k)) r[k] = semigroups[k].concat(first$1[k], second[k]);
			return r;
		} };
	};
	exports.struct = struct;
	/**
	* Given a tuple of semigroups returns a semigroup for the tuple.
	*
	* @example
	* import { tuple } from 'fp-ts/Semigroup'
	* import * as B from 'fp-ts/boolean'
	* import * as N from 'fp-ts/number'
	* import * as S from 'fp-ts/string'
	*
	* const S1 = tuple(S.Semigroup, N.SemigroupSum)
	* assert.deepStrictEqual(S1.concat(['a', 1], ['b', 2]), ['ab', 3])
	*
	* const S2 = tuple(S.Semigroup, N.SemigroupSum, B.SemigroupAll)
	* assert.deepStrictEqual(S2.concat(['a', 1, true], ['b', 2, false]), ['ab', 3, false])
	*
	* @since 2.10.0
	*/
	var tuple = function() {
		var semigroups = [];
		for (var _i = 0; _i < arguments.length; _i++) semigroups[_i] = arguments[_i];
		return { concat: function(first$1, second) {
			return semigroups.map(function(s, i) {
				return s.concat(first$1[i], second[i]);
			});
		} };
	};
	exports.tuple = tuple;
	/**
	* Between each pair of elements insert `middle`.
	*
	* @example
	* import { intercalate } from 'fp-ts/Semigroup'
	* import * as S from 'fp-ts/string'
	* import { pipe } from 'fp-ts/function'
	*
	* const S1 = pipe(S.Semigroup, intercalate(' + '))
	*
	* assert.strictEqual(S1.concat('a', 'b'), 'a + b')
	*
	* @since 2.10.0
	*/
	var intercalate = function(middle) {
		return function(S) {
			return { concat: function(x, y) {
				return S.concat(x, S.concat(middle, y));
			} };
		};
	};
	exports.intercalate = intercalate;
	/**
	* Always return the first argument.
	*
	* @example
	* import * as S from 'fp-ts/Semigroup'
	*
	* assert.deepStrictEqual(S.first<number>().concat(1, 2), 1)
	*
	* @category instances
	* @since 2.10.0
	*/
	var first = function() {
		return { concat: function_1.identity };
	};
	exports.first = first;
	/**
	* Always return the last argument.
	*
	* @example
	* import * as S from 'fp-ts/Semigroup'
	*
	* assert.deepStrictEqual(S.last<number>().concat(1, 2), 2)
	*
	* @category instances
	* @since 2.10.0
	*/
	var last = function() {
		return { concat: function(_$1, y) {
			return y;
		} };
	};
	exports.last = last;
	/**
	* Given a sequence of `as`, concat them and return the total.
	*
	* If `as` is empty, return the provided `startWith` value.
	*
	* @example
	* import { concatAll } from 'fp-ts/Semigroup'
	* import * as N from 'fp-ts/number'
	*
	* const sum = concatAll(N.SemigroupSum)(0)
	*
	* assert.deepStrictEqual(sum([1, 2, 3]), 6)
	* assert.deepStrictEqual(sum([]), 0)
	*
	* @since 2.10.0
	*/
	exports.concatAll = M.concatAll;
	/**
	* Use `void` module instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.semigroupVoid = (0, exports.constant)(void 0);
	/**
	* Use [`getAssignSemigroup`](./struct.ts.html#getAssignSemigroup) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	var getObjectSemigroup = function() {
		return { concat: function(first$1, second) {
			return Object.assign({}, first$1, second);
		} };
	};
	exports.getObjectSemigroup = getObjectSemigroup;
	/**
	* Use [`last`](#last) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getLastSemigroup = exports.last;
	/**
	* Use [`first`](#first) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getFirstSemigroup = exports.first;
	/**
	* Use [`tuple`](#tuple) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getTupleSemigroup = exports.tuple;
	/**
	* Use [`struct`](#struct) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getStructSemigroup = exports.struct;
	/**
	* Use [`reverse`](#reverse) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getDualSemigroup = exports.reverse;
	/**
	* Use [`max`](#max) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getJoinSemigroup = exports.max;
	/**
	* Use [`min`](#min) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getMeetSemigroup = exports.min;
	/**
	* Use [`intercalate`](#intercalate) instead.
	*
	* @category zone of death
	* @since 2.5.0
	* @deprecated
	*/
	exports.getIntercalateSemigroup = exports.intercalate;
	function fold(S) {
		var concatAllS = (0, exports.concatAll)(S);
		return function(startWith, as) {
			return as === void 0 ? concatAllS(startWith) : concatAllS(startWith)(as);
		};
	}
	/**
	* Use [`SemigroupAll`](./boolean.ts.html#SemigroupAll) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.semigroupAll = { concat: function(x, y) {
		return x && y;
	} };
	/**
	* Use [`SemigroupAny`](./boolean.ts.html#SemigroupAny) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.semigroupAny = { concat: function(x, y) {
		return x || y;
	} };
	/**
	* Use [`getSemigroup`](./function.ts.html#getSemigroup) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.getFunctionSemigroup = function_1.getSemigroup;
	/**
	* Use [`Semigroup`](./string.ts.html#Semigroup) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.semigroupString = { concat: function(x, y) {
		return x + y;
	} };
	/**
	* Use [`SemigroupSum`](./number.ts.html#SemigroupSum) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.semigroupSum = { concat: function(x, y) {
		return x + y;
	} };
	/**
	* Use [`SemigroupProduct`](./number.ts.html#SemigroupProduct) instead.
	*
	* @category zone of death
	* @since 2.0.0
	* @deprecated
	*/
	exports.semigroupProduct = { concat: function(x, y) {
		return x * y;
	} };
}) });

//#endregion
export { require_Eq, require_Ord, require_Semigroup };